import { checkAuthStatus } from '@/api/calls/auth';
import { useQuery } from '@tanstack/react-query';

const AUTH_FLAG_KEY = 'has_session';

// Check if user has ever logged in
const hasEverLoggedIn = (): boolean => {
  return localStorage.getItem(AUTH_FLAG_KEY) === 'true';
};

// Set flag when user logs in successfully
export const setAuthFlag = (): void => {
  localStorage.setItem(AUTH_FLAG_KEY, 'true');
};

// Clear flag when user logs out
export const clearAuthFlag = (): void => {
  localStorage.removeItem(AUTH_FLAG_KEY);
};

export const useAuthStatus = () => {
  const { data, refetch } = useQuery({
    queryKey: ['auth-status'],
    queryFn: checkAuthStatus,
    enabled: hasEverLoggedIn(), // Only check API if user has logged in before
    staleTime: 1000 * 60 * 30, // Cache for 30 minutes
    retry: false,
  });

  return { data, refetch };
};
